module.exports = __webpack_public_path__ + "img/2017_horizon.e6520476.jpg";